import { create } from "zustand"
import { createJSONStorage, persist } from "zustand/middleware"

export interface OwnerCooperativeIdentity {
  cooperativeNationalCode: string
  cooperativeName: string
  ceoName: string
  /** From the login CompanyInfo lookup; prefills registration_number in the wizard. */
  registerNumber?: string
  /** Year part of CompanyInfo's register_date ("1400/01/01" -> "1400"); prefills establishment_year. */
  establishmentYear?: string
  /** Registered capital in rial from the official-gazette lookup at login.
   * Absent when unavailable, and the owner types it. */
  registeredCapital?: number
}

interface OwnerAuthState {
  isAuthenticated: boolean
  token: string | null
  refreshToken: string | null
  cooperative: OwnerCooperativeIdentity | null
  setSession: (token: string, refreshToken: string, cooperative?: OwnerCooperativeIdentity) => void
  setAccessToken: (token: string, refreshToken?: string) => void
  clearSession: () => void
}

const initialState = {
  isAuthenticated: false,
  token: null,
  refreshToken: null,
  cooperative: null,
} satisfies Partial<OwnerAuthState>

export const useOwnerAuthStore = create<OwnerAuthState>()(
  persist(
    (set) => ({
      ...initialState,
      setSession: (token, refreshToken, cooperative) =>
        set({ isAuthenticated: true, token, refreshToken, cooperative: cooperative ?? null }),
      setAccessToken: (token, refreshToken) =>
        set((state) => ({ token, refreshToken: refreshToken ?? state.refreshToken })),
      clearSession: () => set(initialState),
    }),
    {
      name: "coop-owner-auth",
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
)
